import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import Grid from "@saleor/components/Grid";
import RadioGroupField from "@saleor/components/RadioGroupField";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { ChangeEvent } from "@saleor/hooks/useForm";
// import { getFormErrors } from "@saleor/utils/errors";
// import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import {
  DiscountDeliveryTypeEnum,
  VoucherClassificationEnum,
  VoucherTypeEnum
} from "../../../types/globalTypes";
import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";

interface VoucherVerticalsProps {
  data: VoucherDetailsPageFormData;
  errors: DiscountErrorFragment[];
  disabled: boolean;
  onChange: (event: ChangeEvent<any>) => void;
}

const VoucherVerticals = ({
  data,
  disabled,
  // errors,
  onChange
}: VoucherVerticalsProps) => {
  const intl = useIntl();

  // const formErrors = getFormErrors(["discountType"], errors);
  useEffect(() => {
    if (data.discountType.toString() === "E_VOUCHER") {
      const newEvent = {
        target: { name: "verticalType", value: VoucherClassificationEnum.ALL }
      };
      onChange(newEvent);
    }
  }, [data.discountType]);

  const verticalTypeChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "All",
        description: "vertical type"
      }),
      value: VoucherClassificationEnum.ALL
    },
    {
      label: intl.formatMessage({
        defaultMessage: "General Merchandise",
        description: "vertical type"
      }),
      value: VoucherClassificationEnum.GENERAL_MERCHANDISE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Food and Beverages",
        description: "vertical type"
      }),
      value: VoucherClassificationEnum.FOOD_AND_BEVERAGES
    },
    {
      disabled:
        disabled ||
        data.type.toString() === "SPECIFIC_PRODUCT" ||
        data.discountType.toString() === "E_VOUCHER" ||
        data.type.toString() === "E_VOUCHER",
      label: intl.formatMessage({
        defaultMessage: "Grocery",
        description: "vertical type"
      }),
      value: VoucherClassificationEnum.GROCERY
    },
    {
      disabled:
        disabled ||
        data.discountType.toString() === "E_VOUCHER" ||
        data.type.toString() === "E_VOUCHER" ||
        data.discountType.toString() === "SHIPPING" ||
        data.type.toString() === "SHIPPING",
      label: intl.formatMessage({
        defaultMessage: "Nationwide Stores",
        description: "vertical type"
      }),
      value: VoucherClassificationEnum.SM_FULFILLED
    }
  ];

  // const [valueTypes, setValueTypes] = React.useState();

  // const defaultVerticalVal = VoucherClassificationEnum.FOOD_AND_BEVERAGES;

  const handleOnChange = e => {
    let newArray = [
      DiscountDeliveryTypeEnum.NEXT_DAY,
      DiscountDeliveryTypeEnum.IN_STORE,
      DiscountDeliveryTypeEnum.EXPRESS_DELIVERY,
      DiscountDeliveryTypeEnum.EXPRESS_LONG_DISTANCE_DELIVERY,
      DiscountDeliveryTypeEnum.NATIONWIDE_DELIVERY,
      DiscountDeliveryTypeEnum.SAME_DAY
    ];
    switch (e.target.value) {
      case VoucherClassificationEnum.GENERAL_MERCHANDISE:
        newArray = [DiscountDeliveryTypeEnum.NEXT_DAY];
        break;
      case VoucherClassificationEnum.FOOD_AND_BEVERAGES:
        newArray = [DiscountDeliveryTypeEnum.EXPRESS_DELIVERY];
        break;
      case VoucherClassificationEnum.SM_FULFILLED:
        newArray = [DiscountDeliveryTypeEnum.NATIONWIDE_DELIVERY];
    }
    if (
      data.discountType.toString() === "SHIPPING" ||
      data.type === VoucherTypeEnum.SHIPPING
    ) {
      newArray = newArray.filter(
        item => item !== DiscountDeliveryTypeEnum.IN_STORE
      );
    }
    const newEvent = {
      target: { name: "deliveryType", value: newArray }
    };
    onChange(newEvent);
  };

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Classification",
          description: "header"
        })}
      />
      <CardContent>
        <Grid variant="uniform">
          <RadioGroupField
            choices={verticalTypeChoices}
            disabled={
              disabled ||
              data.discountType.toString() === "E_VOUCHER" ||
              data.type.toString() === "E_VOUCHER"
            }
            name={"verticalType" as keyof VoucherDetailsPageFormData}
            value={data.verticalType}
            onChange={e => {
              onChange(e);
              handleOnChange(e);
            }}
            // onChange={event => {
            //   onChange(event);
            //   // setValueTypes(event.target.value);
            // }}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};
export default VoucherVerticals;
